export const ERROR_MSG = 'សូមបំពេញព័ត៌មានទាំងស្រុង';
export const ERROR_FULLNAME_MSG = 'សូម​បញ្ចូល​ឈ្មោះ​របស់​អ្នក';
export const ERROR_TEL_MSG = 'សូមបញ្ចូលលេខទូរស័ព្ទរបស់អ្នក។';
